import { useState, useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'zillotasks-color-mode';

// Simple external store so all components share the same value
let currentValue: 'multi' | 'mono' = (localStorage.getItem(STORAGE_KEY) as 'multi' | 'mono') || 'multi';
const listeners = new Set<() => void>();

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function getSnapshot() {
  return currentValue;
}

function setMode(mode: 'multi' | 'mono') {
  currentValue = mode;
  localStorage.setItem(STORAGE_KEY, mode);
  listeners.forEach((cb) => cb());
}

export function useTaskColorMode() {
  const mode = useSyncExternalStore(subscribe, getSnapshot);

  const toggle = useCallback(() => {
    setMode(mode === 'multi' ? 'mono' : 'multi');
  }, [mode]);

  return { colorMode: mode, isMulticolor: mode === 'multi', toggle };
}
